"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Multimedia = void 0;
const react_1 = __importDefault(require("react"));
const media_1 = require("./media");
const multimediaElement_1 = require("./multimediaElement");
const Multimedia = (props) => {
    return (react_1.default.createElement(media_1.MediaWithMimeType, Object.assign({}, props, { elementType: multimediaElement_1.MultimediaElement })));
};
exports.Multimedia = Multimedia;
